import useLocalStorage from '../useLocalStorage'

export type IProductTracking = {
  item_list_name?: string
  item_list_type?: string
  item_category?: string
  index?: number
}
interface IProductTrackingStorageFormat {
  // key is product ID
  [key: string]: IProductTracking
}

const defaultProductTrackingStore = {}

const { stored, set } = useLocalStorage<IProductTrackingStorageFormat>(
  'productTracking',
  defaultProductTrackingStore,
)
const useProductTrackingLocalStorage = () => {
  const getStoredProductTrackingItem = (itemId: string): IProductTracking | undefined =>
    stored.value?.[itemId]

  const storeProductTracking = (value: IProductTrackingStorageFormat) => {
    set({
      ...stored.value,
      ...value,
    })
  }

  const deleteProductTrackingItems = (itemIds: string[]) => {
    const storedCopy = { ...stored.value }

    for (let i = 0; i < itemIds.length; i++) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete storedCopy[itemIds[i]]
    }

    set(storedCopy)
  }

  return {
    getStoredProductTrackingItem,
    storeProductTracking,
    deleteProductTrackingItems,
  }
}

export default useProductTrackingLocalStorage
